<template>
  <div :class="view ? `userImage__${view}` : userImage">
    <img
      v-if="imageSrc"
      :title="username || ''"
      :src="imageSrc"
      @error="showFallbackIcon"
    />
    <div
      v-else-if="username"
      class="avatar"
      :title="username || ''"
      :style="`background-color: ${getColor(username)}`"
    >
      <span> {{ username.initials() }}</span>
    </div>
    <i v-else :title="username || ''" class="material-icons-round"
      >account_circle</i
    >
  </div>
</template>

<script>
import { getHSLColor } from "../../utils/helpers";

export default {
  name: "UserImage",
  data: () => {
    return {
      userIcon: false,
      imageSrc: null
    };
  },
  props: {
    src: {
      default: null,
      type: String
    },
    view: {
      default: null,
      type: String
    },
    username: {
      default: null,
      type: String
    }
  },
  methods: {
    showFallbackIcon() {
      this.imageSrc = null;
    },
    getColor(spaceId) {
      return getHSLColor(spaceId);
    }
  },
  created() {
    this.imageSrc = this.src;
  }
};
</script>
